<div class="title">
  <div class="text-title">
    <div id="titre">
      <div>
        <div><b>Espace client</b></div>
        <div id="etoiles">
          <img src="/assets/pictogrammes/etoiles.svg" />
        </div>
      </div>
    </div>
    <div id="subtitle">
      <div>
        <div>Connectez-vous à votre espace client</div>
        <div id="globe">
          <img src="/assets/pictogrammes/globe.svg" />
        </div>
      </div>
    </div>
  </div>
  <div class="wave">
    <img src="/assets/img/wave.svg" />
  </div>
</div>

<div class="page">
  <h1>Formulaire <span class="color-title">de connexion</span></h1>
  <div class="form">
    <div class="icon-connexion">
      <img src="/assets/pictogrammes/login.svg" />
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="form-connexion">
      <mat-card class="mat-elevation-z">
        <mat-form-field>
          <mat-label>Identifiant</mat-label>
          <input matInput formControlName="username" placeholder="Votre identifiant" autocomplete="off">
          <mat-error *ngIf="form.hasError('required',['username'])">L'identifiant est requis</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Mot de passe</mat-label>
          <input matInput type="{{showPassword ? 'password' : 'text'}}" formControlName="password"
            placeholder="Votre mot de passe">
          <mat-icon matSuffix (click)="toggleVisibility()" class="icon-click"
            matTooltip="{{showPassword ? 'Afficher le mot de passe en clair' : 'Masquer le mot de passe' }}"
            matTooltipPosition="right">
            {{showPassword ? 'visibility_off' : 'visibility'}}
          </mat-icon>
          <mat-error *ngIf="form.hasError('required',['password'])">Le mot de passe est requis</mat-error>
        </mat-form-field>

        <mat-error *ngIf="form.hasError('unauthorized')">Erreur d'identifiant ou de mot de passe</mat-error>

        <button type="submit" mat-raised-button color="primary" class="btn">Connexion</button>
        <a routerLink="/reset-password-request" class="link">> J'ai oublié mon mot de passe</a>
      </mat-card>
    </form>
  </div>
</div>